import { createElement } from "react";
import { Trans } from "react-i18next";
import { deleteHttp } from "@common/api/apiShared";
import { Result } from "@common/api/result";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { IDeleteRiskScenarioDialog } from "./DeleteRiskScenarioDialog";

interface DeleteRiskScenarioResult {
    isDeleted: boolean;
    name: string;
}

export function DeleteRiskScenarioDialogDataMapping(props: IDeleteRiskScenarioDialog) {
    const snackbar = useDotLegalSnackbar();

    const removeMutation = useDotLegalMutation(remove);
    const removeRiskScenario = () => {
        removeMutation.mutateAsync(undefined, {
            onSuccess: (response: Result<DeleteRiskScenarioResult>) => {
                props.onCloseDialog();

                if (response.value().isDeleted) {
                    props.onDeletion();
                    snackbar.show(createElement(Trans, { i18nKey: "dataDeleted", values: { name: props.selectedRiskScenario.name } }));
                } else {
                    snackbar.show(createElement(Trans, { i18nKey: "cantDeleteRiskScenario", values: { name: props.selectedRiskScenario.name } }), "warning");
                }
            },
        });
    };

    async function remove() {
        return await deleteHttp<DeleteRiskScenarioResult>(`/risk-scenarios/${props.selectedRiskScenario.id}`);
    }

    return {
        removeRiskScenario,
        inProgress: removeMutation.isLoading,
    };
}
